<div
  [formGroup]="learningCenterForm"
  id="third-section-input-container"
  class="card p-4"
>
  <h3 style="font-weight: 700; color: #060e9f">
    รายละเอียดส่วนที่ 3
    <span style="font-size: 20px; color: #878787; font-weight: 400"
      >(เพิ่มได้สูงสุด 10 หัวข้อ)</span
    >
  </h3>
  <div
    formArrayName="CONTENT3"
    *ngFor="let content3Group of content3Array.controls; let i = index"
  >
    <div
      [formGroupName]="i"
      *ngIf="content3Group.get('DATA_STATUS').value !== 'remove'"
    >
      <ng-template #extraTemplate>
        <button
          id="remove-item-button-{{ i }}"
          (click)="removeItem(i)"
          class="d-flex justify-content-center align-items-center"
          nz-button
          nzType="primary"
          nzShape="circle"
          nzSize="medium"
          nzTooltipTitle="ลบหัวข้อ"
          nzTooltipPlacement="right"
          nz-tooltip
          nzDanger
        >
          <span nz-icon nzType="close" nzTheme="outline"></span>
        </button>
      </ng-template>

      <nz-card
        class="mb-2"
        nzTitle="หัวข้อที่ {{ countValid(i) + 1 }}"
        [nzExtra]="extraTemplate"
      >
        <div class="row">
          <div class="col-12 col-md-8">
            <!-- Change here -->
            <div class="row">
              <div class="col">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24"
                    >ชื่อหัวข้อ<lifedi-require></lifedi-require
                  ></nz-form-label>
                  <nz-form-control [nzSpan]="24" nzErrorTip="โปรดระบุ">
                    <input
                      id="third-section-title-input-{{ i }}"
                      formControlName="CONTENT3_TITLE"
                      nz-input
                      placeholder="ชื่อหัวข้อ"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <nz-form-item>
              <nz-form-label [nzSpan]="24"
                >รายละเอียด<lifedi-require></lifedi-require
              ></nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="โปรดระบุ">
                <!-- <textarea
                formControlName="CONTENT3_DETAIL"
                nz-input
                rows="4"
                class="form-control"
                placeholder="รายละเอียด"
              ></textarea> -->

                <div
                  [ngClass]="{
                    error:
                      content3Array.at(i).get('CONTENT3_DETAIL').invalid &&
                      content3Array.at(i).get('CONTENT3_DETAIL').dirty
                  }"
                >
                  <angular-editor
                    id="third-section-text-editor-{{ i }}"
                    placeholder="ระบุคำอธิบาย"
                    style="margin: 0 auto"
                    [config]="editorConfig"
                    formControlName="CONTENT3_DETAIL"
                  >
                  </angular-editor>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="col-12 col-md-4">
            <!-- Change here -->
            <div class="row">
              <div class="col-12">
                <nz-form-label [nzSpan]="24"
                  >ไอคอนหรือภาพประกอบ<lifedi-require></lifedi-require
                ></nz-form-label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <nz-upload
                  class="avatar-uploader"
                  nzName="third-section-image-uploader-{{ i }}"
                  nzListType="picture-card"
                  [nzShowUploadList]="false"
                  [nzBeforeUpload]="beforeUpload"
                  [nzCustomRequest]="successRequest"
                  (nzChange)="handleChange($event, i)"
                  [(nzFileList)]="fileLists[i]"
                  nzTooltipTitle="คลิกเพื่ออัปโหลดไอคอนหรือภาพประกอบ"
                  nzTooltipPlacement="right"
                  nz-tooltip
                >
                  <ng-container *ngIf="!imageUrls[i]">
                    <i
                      nz-icon
                      nzType="plus-circle"
                      nzTheme="outline"
                      style="font-size: 40px; color: #878787"
                    ></i>
                  </ng-container>

                  <img
                    *ngIf="
                      imageUrls[i] && imageUrls[i]['dataStatus'] !== 'remove'
                    "
                    id="third-section-image-{{ i }}"
                    [src]="imageUrls[i]['imageUrl']"
                    alt="{{ i }}"
                    style="
                      max-width: 100px;
                      max-height: 100px;
                      width: 100px;
                      height: auto;
                    "
                  />
                </nz-upload>
                <div class="row">
                  <div class="col-12">
                    <span>แนะนำให้ใช้รูปภาพขนาด 100x100 พิกเซล</span>
                    <div
                      *ngIf="
                        content3ImageArray.at(i).invalid &&
                        (content3ImageArray.at(i).dirty ||
                          content3ImageArray.at(i).touched)
                      "
                      class="alert alert-danger"
                    >
                      กรุณาอัปโหลดรูปภาพ
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nz-card>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex justify-content-center align-items-center">
      <button
        id="add-item-button"
        (click)="addContent3Group()"
        class="d-flex justify-content-center align-items-center"
        style="background-color: #00af80"
        nz-button
        nzType="primary"
        nzShape="circle"
        nzSize="large"
        nzTooltipTitle="เพิ่มหัวข้อใหม่"
        nzTooltipPlacement="right"
        nz-tooltip
      >
        <span
          nz-icon
          style="color: white; font-size: 20px"
          nzType="plus"
          nzTheme="outline"
        ></span>
      </button>
    </div>
  </div>
</div>
